import {
  ErrorHandler,
  Injectable,
  InjectionToken,
  Injector,
} from "@angular/core";
import * as Rollbar from "rollbar";

export const RollbarService = new InjectionToken<Rollbar>("rollbar");

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(err: any) {
    var rollbar = this.injector.get(RollbarService);
    if (err.status && err.statusText && err.url) {
      rollbar.error(err.status + ": " + err.statusText + ", " + err.url);
    } else {
      rollbar.error(err);
    }
    console.error(err);
  }
}
